import { DefaultButton, PrimaryButton } from ".";
import FlexBox from "../../layouts/Flexbox";

export function SaveAndCancelButton({
  primaryButtonProps = { type: "submit" },
  primaryButtonText = "Save Details",
  secondaryButtonText = "Discard Changes",
  secondaryButtonProps = {},
  onActionButtonClick,
  onCancelButtonClick,
  showPrimaryButton = true,
  showSecondaryButton = true,
  loading = false,
}: any) {
  return (
    <FlexBox gap={1}>
      {showSecondaryButton && (
        <DefaultButton
          onClick={onCancelButtonClick}
          fullWidth
          {...secondaryButtonProps}
          sx={{
            ...secondaryButtonProps?.sx,
          }}
        >
          {secondaryButtonText}
        </DefaultButton>
      )}

      {showPrimaryButton && (
        <PrimaryButton
          onClick={onActionButtonClick}
          loading={loading}
          fullWidth
          {...primaryButtonProps}
          sx={{ ...primaryButtonProps?.sx }}
        >
          {primaryButtonText}
        </PrimaryButton>
      )}
    </FlexBox>
  );
}
